import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export interface IOrderFormDeleteService {
  orderId: number
}

export const orderFormDeleteService = async ({
  orderId,
}: IOrderFormDeleteService) => {
  const { data } = await api.get<ResponseAPI>(`/excluirpedido/${orderId}`)

  return data
}
